<template>
	<div class="profile-dropdown">
		<div class="dropdown-item-group">
			<router-link class="dropdown-item" exact :to="{ name: 'userProfilePage' }">My Profile</router-link>
			<router-link class="dropdown-item" exact :to="{ name: 'userSettings' }">Edit My Profile</router-link>
			<router-link class="dropdown-item" exact :to="{ name: 'Settings/UserPrivacySettings' }">Privacy
				Settings</router-link>
			<router-link class="dropdown-item" exact :to="{ name: 'Settings/UserChangePassword' }">Change
				Password</router-link>
		</div>
		<div class="dropdown-item-group">
			<router-link class="dropdown-item" exact
				:to="{ name: 'companyProfile', params: { companyId: getID(userInfo.company) } }">My
				Company</router-link>
			<router-link class="dropdown-item" exact :to="{ name: 'Settings/CompanySettings' }">Edit My 
				Company</router-link>
			<router-link class="dropdown-item" exact :to="{ name: 'Settings/CompanyEmployees' }">Company
				Employees</router-link>
		</div>
		<div class="dropdown-item-group">
			<router-link class="dropdown-item" exact :to="{ name: 'Settings/Invoices' }">Invoices to Pay</router-link>
			<router-link class="dropdown-item" exact :to="{ name: 'ccAllEvents' }">Book Events</router-link>
			<router-link class="dropdown-item" exact :to="{ name: 'ccMyEvents' }">My Booked Events</router-link>
		</div>
		<div class="dropdown-item-group">
			<a class="dropdown-item faq" @click.prevent="openFAQ()">FAQ</a>
			<div class="dropdown-item" @click.prevent="logOut">Log out</div>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import getIDfromURL from '../utils/getIDfromURL';

export default {
	name: 'ProfileMenu',
	props: {
		userInfo: {
			type: Object,
			required: true
		},
	},
	methods: {
		...mapActions({
			userLogout: 'auth/userLogout',
		}),
		getID(url) {
			return getIDfromURL(url);
		},
		async logOut() {
			await this.userLogout();
			this.$router.push({ name: 'PublicEvents' });
		},
		openFAQ() {
			window.open('/FAQ.pdf', '_blank');
		},
	},
}
</script>

<style scoped>
	.profile-image-holder {
		display: flex;
		align-items: center;
		flex-direction: column;	
		padding-top: 25px;
		position: relative;
	}

	.profile-image-holder .arrow-down {
		position: absolute;
		top: 45%;
		right: -15px;
		border: solid black;
		border-width: 0 1px 1px 0;
		display: inline-block;
		padding: 3px;
		transform: rotate(45deg);
		-webkit-transform: rotate(45deg);
	}

	.profile-image-holder:hover .arrow-down {
		border: solid #bd9d5f;
		border-width: 0 1px 1px 0;
	}

	.profile-name {
		color: rgb(41, 41, 41);
		font-family: "Montserrat", sans-serif;
		font-size: 10px;
		text-transform: uppercase;
		margin-top: 2px;
	}
	.profile-menu {
		position: relative;
		list-style-type: none;
	}

	.profile-dropdown {
		position: absolute;
		top: 57px;
		left: 15px;
		background-color: #fff;
		box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
		display: none;
		padding: 8px 8px 0 8px;
	}
	
	.dropdown-item-group:not(:last-child) {
		border-top-left-radius: 0;
		margin-bottom: 7px;
		color: #333;
		border-bottom: 1px solid #efefef;
		padding-bottom: 8px;
	}

	.dropdown-item {
		color: #333;
		cursor: pointer;
		font-size: 14px;
		text-align: left;
		font-family: 'Montserrat', sans-serif;
		padding: .3rem 1.5rem !important;
	}
	.dropdown-item.faq {
		color: #333;
	}

	.dropdown-item:hover {
		color: #bd9d5f;
	}

	.profile-menu:hover .profile-dropdown {
		display: block;
	}

	a.dropdown-item:hover {
		color: #bd9d5f;
	}

	.dropdown-item.router-link-exact-active {
		color: #bd9d5f;
	}
	
	.dropdown-item.active, .dropdown-item:active, .dropdown-item:focus {
		background-color: #f8f9fa !important;
	}
</style>